import {
  AgentType,
  hasEditLifecycleCapability,
  type AgentLifecycleTagSource,
} from "@superblocksteam/shared";

/**
 * Product gate for the Admin Databases nav entry and route guard.
 *
 * Same topology rules as Clark's advertising gate: rollout flag, then either
 * cloud-prem (flag is the deployment opt-in) or SaaS ONPREMISE with an active
 * agent that registered edit-mode lifecycle (`ensure_database` + `edit:*`).
 * Advisory / UX only — server ensure/dispatch remains authoritative.
 */
export function isManagedNativeDatabasesAvailable({
  agents,
  managedNativeDbEnabled,
  organization,
  isCloudPrem = false,
}: {
  agents?: readonly AgentLifecycleTagSource[];
  managedNativeDbEnabled: boolean;
  organization?: { agentType?: AgentType } | null;
  /**
   * Cloud-prem managed data planes use `AgentType.MULTITENANT` and do not
   * register OPA lifecycle tags. When the control plane is cloud-prem,
   * the rollout flag alone is the product gate (Helm / flag JSON opt-in).
   */
  isCloudPrem?: boolean;
}) {
  if (!managedNativeDbEnabled) {
    return false;
  }
  if (isCloudPrem) {
    return true;
  }
  if (organization?.agentType !== AgentType.ONPREMISE) {
    return false;
  }
  return hasEditLifecycleCapability(agents);
}
